import React from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

const Slider = ({ linkData, interval = 3000 }) => {
  return (
    <Carousel
      showThumbs={false}
      infiniteLoop
      useKeyboardArrows
      autoPlay
      interval={interval}
    >
      {linkData && linkData.length > 0 ? (
        linkData.map((item) => (
          <div key={item.id}>
            <div
              style={{
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                marginTop: 30,
                height: 425,
                width: "100%",
                margin: "0 auto",
                borderRadius: 10,
                backgroundImage: `url(${item.imageUrl})`,
              }}
            ></div>
          </div>
        ))
      ) : (
        <div>
          <div
            style={{
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              height: 425,
              width: "100%",
              margin: "0 auto",
              backgroundImage: `url(/path/to/default/image.jpg)`,
            }}
          ></div>
        </div>
      )}
    </Carousel>
  );
};

export default Slider;
